import {
  Button,
  Card,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import VeerisettyCollege from './TC-Forms/VeerisettyCollege';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
export default function TCPage() {
  const [StudentId, setStudentId] = useState('');
  const [searchValue, setSearchValue] = useState('');
  return (
    <>
      {' '}
      <Card className=' p-4 border-t max-w-5xl'>
        <div className='max-w-5xl pb-6 '>
          <Typography variant='h6' className='text-blue-600'>
            {' '}
            Search Student
          </Typography>
          <Card className=' mb-4 p-4 border rounded'>
            <Typography variant='body1' className='mb-2'>
              Enter Student Id and search for managing the Transfer Certificate
              Details.
            </Typography>
            <div className='flex items-end flex-wrap gap-2'>
              <TextField
                value={searchValue}
                id='studentId'
                size='small'
                label='Student Id'
                className=' mr-10 mt-2 w-60'
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      {!!searchValue && (
                        <IconButton
                          onClick={() => {
                            setSearchValue('');
                            setStudentId('');
                          }}
                        >
                          <CloseIcon></CloseIcon>
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => setSearchValue(e.target.value)}
              ></TextField>

              <Button
                variant='contained'
                disabled={!searchValue}
                onClick={() => setStudentId(searchValue)}
              >
                Search
              </Button>
            </div>
          </Card>
        </div>{' '}
        <Typography variant='h6' className='text-blue-600'>
          {' '}
          Transfer Certificate Details
        </Typography>
        <VeerisettyCollege StudentId={StudentId} />
      </Card>
    </>
  );
}
